module.exports = __webpack_public_path__ + "assets/word_manage.4ca84e42.svg";